/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import classnames from 'classnames';
import * as React from 'react';

import { orderTemplateLinesStatus } from '../order-template';

export interface IOrderTemplateLinesStatusMessageProps {
    className?: string;
    errorType: orderTemplateLinesStatus;
    text?: string;
}

export const OrderTemplateLinesStatusMessage: React.FC<IOrderTemplateLinesStatusMessageProps> = ({ className, errorType, text }) => {
    switch (errorType) {
        case 'EMPTY':
            return (
                <p className={classnames('ms-order-template-lines__message-empty', className)}>
                    { text }
                </p>
            );
        case 'FAILED':
            return (
                <p className={classnames('ms-order-template-lines__message-failed', className)}>
                    { text }
                </p>
            );
        case 'LOADING':
        default:
            return (
                <p className='ms-order-template-lines__message-waiting'>
                    { text }
                </p>
            );
    }
};
